import deviceInfoRedux from 'Modules/.common/.components/vidfleetInformation/redux/reducer';
import showJSONCompareRedux from 'Modules/.common/.components/showJSONCompare/redux/reducer';
import rawMessageViewRedux from  'Modules/devices/.components/rawMessageView/redux/reducer';
import entityTagPickerRedux from 'Modules/.common/.components/EntityTagPicker/redux/reducer';
import tagPickerRedux from 'Modules/.common/.components/TagPicker/redux/reducer';
import resetPasswordRedux from 'Modules/.common/.components/resetPassword/redux/reducer';
import resetEmailRedux from 'Modules/.common/.components/resetEmail/redux/reducer';
import resendInviteRedux from 'Modules/.common/.components/resendInvite/redux/reducer';



//export redux objects
export default {
	deviceInfoRedux,
	showJSONCompareRedux,
	rawMessageViewRedux,
	entityTagPickerRedux,
	tagPickerRedux,
	resetPasswordRedux,
	resetEmailRedux,
	resendInviteRedux
};